import { render, staticRenderFns } from "./list.vue?vue&type=template&id=741dc4c6"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('741dc4c6')) {
      api.createRecord('741dc4c6', component.options)
    } else {
      api.reload('741dc4c6', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=741dc4c6", function () {
      api.rerender('741dc4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/commodityManagement/deployment/list.vue"
export default component.exports